import { html } from 'lit';
const PlayFill =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m10.217 4.787 6.358 3.576c.774.436 1.415.797 1.893 1.126.48.331.938.723 1.188 1.278a3 3 0 0 1 0 2.465c-.25.556-.708.948-1.188 1.28-.478.328-1.119.689-1.893 1.124l-6.358 3.577c-.748.42-1.37.77-1.883 1-.52.233-1.079.415-1.671.348a3 3 0 0 1-2.096-1.226c-.349-.483-.464-1.06-.516-1.626C4 17.148 4 16.435 4 15.577V8.423c0-.858 0-1.57.051-2.132.052-.567.167-1.143.516-1.627A3 3 0 0 1 6.663 3.44c.592-.067 1.15.115 1.67.348.515.23 1.136.58 1.884 1" clip-rule="evenodd"/>
  </svg>
`;
export default PlayFill;
